// Quattro WebSocket client wrapper.
// Auto-reconnect, JSON message routing, simple subscription API.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function wsUrlFor(code, user_id, name, avatar = "default") {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const params = new URLSearchParams({ user_id, name, avatar });
  return `${base}/api/ws/room/${code}?${params.toString()}`;
}

export class QuattroSocket {
  constructor({ code, user_id, name, avatar = "default" }) {
    this.code = code;
    this.user_id = user_id;
    this.name = name;
    this.avatar = avatar;
    this.ws = null;
    this.listeners = new Set();
    this._closed = false;
    this._retry = 0;
  }

  connect() {
    this._closed = false;
    const url = wsUrlFor(this.code, this.user_id, this.name, this.avatar);
    try { this.ws = new WebSocket(url); } catch (e) { this._scheduleReconnect(); return; }
    this.ws.onopen = () => { this._retry = 0; this._emit({ type: "open" }); };
    this.ws.onmessage = (e) => {
      try { this._emit(JSON.parse(e.data)); } catch {}
    };
    this.ws.onclose = (e) => {
      this._emit({ type: "close", code: e.code });
      if (!this._closed && e.code !== 4404 && e.code !== 4403) {
        this._scheduleReconnect();
      }
    };
    this.ws.onerror = () => { /* close handler will fire next */ };
  }

  _scheduleReconnect() {
    this._retry += 1;
    const delay = Math.min(8000, 500 * 2 ** Math.min(this._retry, 5));
    setTimeout(() => { if (!this._closed) this.connect(); }, delay);
  }

  send(obj) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(obj));
      return true;
    }
    return false;
  }

  subscribe(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  _emit(msg) {
    for (const fn of this.listeners) {
      try { fn(msg); } catch (e) { console.error(e); }
    }
  }

  close() {
    this._closed = true;
    try { this.ws && this.ws.close(); } catch {}
    this.listeners.clear();
  }
}
